<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
                Movimientos Mastercard
      </b-card-header>      
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <label>Fecha desde</label>
            <br />
            <KitsDateTime v-model="model.desde" :currentValue="model.desde" />
          </div>
          <div class="col-md-6">
            <label>Fecha hasta</label>
            <br />
            <KitsDateTime v-model="model.hasta" :currentValue="model.hasta" />
          </div>
          <div class="col-md-6">
            <label>Tipo de movimiento</label>
            <br />
            <KitsCombo
              v-model="model.tipo"
              v-bind:items="tipos"
              propertyName="Name"
              propertyID="EntityID"
              :todos="true"
            ></KitsCombo>
          </div>
        </div>  
        <div class="row">
          <div class="col-md-12 text-right">
            <filter-button @click="filtrar"></filter-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card style="margin: 20px">
      <b-card-body>        
        <b-card-header v-if="model.primeraBusquedaEjecutda" header-tag="header" class="p-1" role="tab"
          >Movimientos de mi tarjeta</b-card-header
        >
        <div v-show="showMessage" >
          <div class="text-center">
            <div>No se encontraron registros</div>
            <img src="/img/ic_no_resultado.png" style="width: 200px" />
          </div>        
        </div>
        <div v-if="movimientos.length > 0">
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-12">
              <download-csv
                v-if="movimientos.length > 0"
                class   = "btn btn-success"
                :data   = "movimientos"
                :fields = "csv.json_fields"
                :labels = "csv.labels"
                :name    = "exportFileName"
                delimiter = ";">
                <i class="fa fa-fw fa-file-excel"></i>Exportar
              </download-csv>
            </div>  
          </div>        
          <div
            class="row"
            v-for="item in movimientos"
            @click="itemClicked(item)"
            v-bind:key="item.ReceiptID"
            style="
              padding: 5px;
              border-bottom: 1px solid #d6d4d4;
              cursor: pointer;
              margin-right: 0;
              margin-left: 0;
            "
          >
            <div class="col-2" style="padding-top: 10px">
              <img :src="item.Image" style="width: 40px" alt />
            </div>
            <div class="col-4" style="padding-top: 20px">
              {{ item.Description }}
            </div>
            <div class="col-4 text-right" style="padding-top: 10px">
              {{ item.FormattedAmount }}
              <br />
              {{ item.FormattedDate }}
            </div>
          </div>           
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-12">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import JsonCSV from "vue-json-csv";
import KitsCombo from "@/components/KitsCombo";
import KitsDateTime from "@/components/KitsDateTime";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: {KitsCombo, KitsDateTime},
  data() {
    return {
      movimientos: [],
      movimiento: {},
      tipos: [],
      model: {
        desde: "",
        hasta: "",
        tipo: null ,
        primeraBusquedaEjecutda: false      
      },

      csv: {
        json_fields: [
          "Description",
          "Amount",
          "FormattedDate"
        ],
        labels: {
          Description: "Descripcion",
          Amount: "Monto",
          FormattedDate: "Fecha"         
        },
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8"
            }
          ]
        ]
      }      
    };
  },
  computed: {
    exportFileName: function() {
      var d = new Date();
      var datestring = datetimeHelpers.getFormattedDDMMYYYY(d, "");
      var temp = "mismovimientos" + datestring + ".csv";

      return temp;
    },

    showMessage: function(){
      return this.movimientos.length == 0 && this.model.primeraBusquedaEjecutda;
    }
  },
  methods: {
    filtrar() {
      let context = this;      
      if (datetimeHelpers.compareFromTo(this.model.desde, this.model.hasta)) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La fecha hasta debe ser superior a la fecha desde",
          this
        );
        return;
      }

      if (
        datetimeHelpers.compareDifference(
          this.model.desde,
          this.model.hasta,
          62
        )
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El rango de fechas ingresado no puede superar los 2 meses",
          this
        );
        return;
      }

      let req = {
        Count: context.$store.getters.ULTMOVIMIENTOSOBTENERTARJETAS,
        IsMobile: false,
        DateFrom: this.model.desde,
        DateTo: this.model.hasta,
        MovementType: this.model.tipo
      };

      axiosHelpers.axiosPost(
        "Mastercard/CardMovementsForWallet",
        req,
        this,
        function (data) {
          for (let i = 0; i < data.ResponseVM.Items.length; i++) {
            data.ResponseVM.Items[i].Image = generalHelpers.getLocalImage(
              data.ResponseVM.Items[i].Image
            );
          }

          context.movimientos = data.ResponseVM.Items;
        }        
      );
      this.model.primeraBusquedaEjecutda = true;
    },
    itemClicked(item) 
    {
      let context = this;
       // -- Si tiene Impuestos, lo redireccionamos al detalle
        if (item.HasMovementTaxes)
        {

          context.$router.push({ name: "ImpuestoMovimientoMastercard", params: 
                { 
                    mastercardMovementID: item.MastercardMovementID,
                    image: item.Image,
                    receiptName: item.Description,
                    receiptDate: item.FormattedDate
                }});
        }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  beforeMount: function () {
    let context = this;

    // context.filtrar();

    console.log("model: " + context);    
    axiosHelpers.axiosGet(
      "Mastercard/GetMastercardMovementsTypes",
      {},
      this,
      function(data) {
        context.tipos = data.ResponseVM.Items;
      }
    );
  },
  mounted: function () {
      this.model.desde = datetimeHelpers.getMonthStart();
      this.model.hasta = datetimeHelpers.getNextDay();  
  },
  watch: {},

};
</script>